@Controller('ib-gift-cards-configuration-form-module',
    ['$scope'], [])
class ibDatepickerController implements ng.IController {
    private dateOptions;
    constructor (private $scope) {
        let maxDate2Months = new Date();
        maxDate2Months.setMonth(maxDate2Months.getMonth() + 2);
        const minDate = new Date();
        minDate.setDate(minDate.getDate() +2);
        this.dateOptions = {
            showWeeks: false,
            minDate: minDate,
            maxDate: maxDate2Months
        };
    }
}
